<template>
  <div class="d-requests">
    <module-spinner
      :active="loading && reviewRequestsTotal === 0"
      :floating="true"
    />
    <module-button
      v-if="userIsRole([1])"

      class="mt0 mb"

      button="primary"
      size="m"
      label="Start New Request"
      link="request"
    />
    <h1
      v-if="content.title"

      :class="[
        `h3`,
        {
          'mt0': !userIsRole([1, 2]),
        }
      ]"

      v-html="content.title"
    />
    <p
      v-if="content.copy"

      class="p"

      v-html="content.copy"
    />
    <transition
      name="fade"
      mode="out-in"
    >
      <div
        v-if="reviewRequestsTotal > 0"

        key="requests-table"
      >
        <module-table
          :columns="columns"
          :rows="reviewRequests.results"
          :row-click="true"
          :row-title="getRowTitle"
          @row-click="onRowClick"
        />

        <div class="d-requests__more">
          <p class="p">Showing <strong>{{ reviewRequestsLength }}</strong> of <strong>{{ reviewRequestsTotal }}</strong> Results</p>
          <module-button
            v-if="reviewRequests.next"

            @click.native="getNextPage"

            button="primary"
            label="Load more"
            :loading="loading"
          />
        </div>
      </div>
      <div
        v-else-if="reviewRequestsTotal === 0 && !loading && userIsRole([1])"

        key="no-requests"
      >
        <p class="p">You have no requests. Please request a new <module-link link="request" label="review here" color="secondary" />.</p>
      </div>
      <p v-else-if="reviewRequestsTotal === 0 && !loading && userIsRole([2,3])" class="fw-bold">No current X-Ray upload requests</p>
    </transition>
  </div>
</template>

<script>
// Vuex
import { mapGetters, mapActions } from 'vuex';

// Services
import { toDateString } from 'services/dateTime';

// Models
import { statusMap } from 'models/review';

// Modules
import ModuleButton from 'modules/Button';
import ModuleSpinner from 'modules/Spinner';
import ModuleLink from 'modules/Link';
import ModuleTable from 'modules/Table';

// Export
export default {
  name: `ui-dashboard-requests`,

  // Components
  components: {
    ModuleButton,
    ModuleSpinner,
    ModuleLink,
    ModuleTable,
  },

  // Data
  data() {
    return {
      loading: true,
    };
  },


  computed: {
    ...mapGetters(`auth`, [
      `user`,
      `userRole`,
      `userIsRole`,
      `showTour`,
    ]),
    ...mapGetters(`review`, [
      `reviewRequests`,
      `reviewRequestsLength`,
      `reviewRequestsTotal`,
      `reviewNomenclatureBySlugAndId`,
    ]),
    content() {
      const map = {
        1: {
          title: `My Requests`,
        },
        2: {
          title: `My Procedures and X-Ray Requests`,
          copy: `Requests for X-Rays from procedures you have carried out on patients.`,
        },
        3: {
          title: `My Procedures and X-Ray Requests`,
          copy: `Requests for X-Rays from procedures you have carried out on patients.`,
        },
        42: {
          title: `Procedure Reviews`,
          copy: `Here you can peer-review submissions from dentists and approve or deny them.`,
        },
      };

      return map[this.userRole.role] || {};
    },
    columns() {
      const status = {
        heading: `Status`,
        value: request => statusMap[request.state],
      };

      const name = {
        heading: `Procedure`,
        // value: request => (request.procedure || {}).name,
        value: request => this.reviewNomenclatureBySlugAndId(`procedure`, request.procedure) || {},
      };

      const rating = {
        heading: `Rating`,
        value: request => {
          const review = request.review || {};

          return review.rating ? `${review.rating}/10` : false;
        },
      };

      const date ={
        heading: `Submitted On`,
        value: request => toDateString((request || {}).created_at || ``),
      };

      const link = {
        heading: `Link`,
        hidden: true,
        align: `right`,
        value: () => ({
          is: ModuleButton,
          bind: {
            label: `Submit review`,
            button: `primary`,
            size: `s`,
            icon: `arrow-right`,
          },
        }),
      };

      const patient = [
        status,
        name,
        rating,
        date,
        link,
        // id,
      ];

      const doctor = [
        status,
        name,
        rating,
        date,
        link,
        // id,
      ];

      const reviewer = [
        status,
        name,
        rating,
        date,
        link,
      ];

      const admin = [
        status,
        name,
        {
          heading: `Reviewed By`,
          value: request => request.is_answered ? `{{ Dentist }}` : null,
        },
        {
          heading: `Reviewed On`,
          value: request => request.is_answered ? `{{ date }}` : null,
        },
        // id,
        link,
      ];

      const columns = {
        1: patient,
        2: doctor,
        3: reviewer,
        42: admin,
      };

      return columns[this.userRole.role] || [];
    },
  },

  // Methods
  methods: {
    ...mapActions(`review`, [
      `getReviewRequests`,
      `getReviewRequestsDoctor`,
    ]),
    getReviews() {
      return this.getReviewRequests();
    },
    getNextPage() {
      if (this.loading) return false;

      this.loading = true;

      setTimeout(() => {
        this.getReviews(this.reviewRequests.next)
          .then(() => this.loading = false);
      }, 300);
    },
    onRowClick(id, row) {
      this.$router.push({
        name: this.userRole.role >= 2 && row.state < 3 ? `request-complete` : `dashboard-review`,
        params: {
          id,
        },
      });
    },
    startReviewing() {
      this.$router.push({
        name: `dashboard-next-review`,
      });
    },
    getRowTitle(row) {
      // If am reviewer then do not show this stuff as its PII
      if( this.userRole.role === 3 ) {
        return ``;
      }
      const doctor = (row.doctor || {
        email: ``,
        first_name: ``,
        last_name: ``,
      });

      const full_name = [doctor.first_name, doctor.last_name].join(` `);
      return `${full_name} <${doctor.email}>`.trim();
    },
  },

  // Lifecycle
  created() {
    this.getReviews()
      .then(() => this.loading = false);
  },
};
</script>



// WEBPACK FOOTER //
// Requests.vue?57f680e0